// Where the help centre's public API lives: photohawk-serverless api-support-kb's GET /help/… on kb.api.<domain>
// (published articles only, no sign-in). The deployment's env decides the domain, on the server and in the browser
// alike (window.__PH_ENV__), so both read the same store.

import { deploymentEnv, type DeploymentEnv } from "@/lib/homeFlag";

export const helpApiBaseFor = (env: DeploymentEnv): string => `https://kb.api.${env === "prod" ? "photohawk.com" : "photohawk-staging.com"}`;

export const helpApiBase = (host?: string): string => helpApiBaseFor(deploymentEnv(host));

/** An image uploaded in the platform editor (":::figure upload:<id>"): served by the API's public redirect. */
export const helpUploadUrl = (imageId: string, host?: string): string => `${helpApiBase(host)}/help/images/${encodeURIComponent(imageId)}`;
